/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import schedulesPageParameters from './__generated__/SchedulesPageQuery$parameters.ts';
import type { SchedulesPageQuery } from './__generated__/SchedulesPageQuery.graphql.ts';

type SchedulesEntryPointComponent = EntryPointComponent<
	{
		teamSchedulesQuery: SchedulesPageQuery;
	},
	{},
	{},
	{}
>;

export const schedulesEntryPoint: EntryPoint<SchedulesEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForInteraction<SchedulesEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-schedules", jiraSpaEntry: "async-servicedesk-schedules" */ './SchedulesPage.tsx',
		),
		getPreloadProps: ({
			context: { match },
			tenantContext: { cloudId },
		}: EntryPointRouteParams) => {
			const projectKey = match.params?.projectKey ?? '';

			// Both teamSchedules and shifts omit startTime/endTime on initial fetch.
			// The backend resolves the current week from the Jira user timezone
			// and returns it as resolvedDateRange in the response.
			return {
				queries: {
					teamSchedulesQuery: {
						parameters: schedulesPageParameters,
						variables: {
							cloudId,
							input: { cloudId, projectKey },
							shiftsInput: { cloudId, projectKey },
							wfoSummaryInput: { cloudId, projectKey },
							includeWfoForecastingBannerPreload: Boolean(
								fg('wfo_forecasting_dashboard_creation_preloaded_query'),
							),
							first: 10,
							isInitialFetch: true,
						},
						options: { fetchPolicy: 'store-and-network' as const },
					},
				},
			};
		},
	});
